import { escapeHTML } from '@lumapps/utils/string/escapeHTML';
import type { HTMLSerializeOptions } from '@lumapps/wrex/serialization/html/toHTML/types';

import type { IframeElement } from '../../types';

export const IFRAME_ELEMENTS: HTMLSerializeOptions['elements'] = {
    iframe: (node: IframeElement) => {
        const title = node.title ? ` title="${escapeHTML(node.title)}"` : '';
        const provider = node.provider ? ` data-provider="${escapeHTML(node.provider)}"` : '';

        if (typeof node.src === 'object' && node.src.doc) {
            return `<iframe srcdoc="${escapeHTML(node.src.doc)}"${title}${provider}></iframe>`;
        }

        const src = typeof node.src === 'string' ? node.src : '';
        return `<iframe src="${escapeHTML(src)}"${title}${provider}></iframe>`;
    },
};
